import type { MotionValue } from "motion";
import { useMotionValueEvent, motion, useTransform, easeInOut } from "motion/react";
import { useState } from "react";

const getStyles = (scrollProgress: MotionValue<number>, currValue: number, finalValue: number) => {
  // Determine the position of the current digit in the count up
  const segmentStart = (currValue - 1) / finalValue;
  const segmentEnd = currValue / finalValue;

  // Determine when we should animate out this digit
  const nextSegmentStart = currValue / finalValue;
  const nextSegmentEnd = nextSegmentStart + (segmentEnd - segmentStart) * 0.2;

  const y = useTransform(scrollProgress, [segmentStart, segmentEnd, nextSegmentEnd], [20, 0, nextSegmentStart === 1 ? 0 : -20], {
    ease: easeInOut,
  });
  const opacity = useTransform(scrollProgress, [segmentStart, segmentEnd, nextSegmentEnd], [0, 1, nextSegmentStart === 1 ? 1 : 0], {
    ease: easeInOut,
  });
  return { y, opacity };
};

/**
 * Counts up to a given value based on the scroll progress
 * @param value The value to count up to
 * @param scrollProgress The current scroll progress
 * @returns The current count
 */
export default function CountUp({ value, scrollProgress }: { value: number; scrollProgress: MotionValue<number> }) {
  const digits = [];
  for (let i = 0; i <= value; i++) {
    digits.push(i);
  }

  return (
    <div className='relative overflow-hidden'>
      <div className='invisible pointer-events-none'>{value}</div>

      {digits.map((digit) => {
        const digitStyles = getStyles(scrollProgress, digit, value);
        return (
          <motion.span key={digit} className='absolute inset-0 flex items-center justify-center tabular-nums' style={digitStyles}>
            {digit}
          </motion.span>
        );
      })}
    </div>
  );
}
